export default {
  removal: 'R',
  unknown: 'unknown',
};
